<template>
  <BittsButton
    :text="label"
    :loading="isRedirecting"
    :size="size"
    type="neutral"
    variant="outline"
    @click="installSlack"
  >
    <template #icon>
      <BittsSvg svg="slackIcon" class="mr-6 w-12 h-12" />
    </template>
  </BittsButton>
</template>

<script setup lang="ts">
import { BittsButton, type BittsButtonSize, BittsSvg } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';
import { ls } from '@/local_storage';

const {
  nextUrl,
  isSlackEnabled = false,
  size = 'small',
} = defineProps<{
  nextUrl?: string;
  isSlackEnabled?: boolean;
  size?: BittsButtonSize;
}>();

const isRedirecting = ref(false);

const label = computed(() =>
  isSlackEnabled ? 'Reauthorize Connection' : 'Connect to Slack',
);

async function installSlack() {
  isRedirecting.value = true;
  ls.nextUrl.set(nextUrl);
  const { data, error } = await crossbeamApi.GET('/v0.1/slack/install-url');
  if (error) {
    captureException(error);
    return;
  }
  window.location.href = data.slack_install_url;
}
</script>
